export const technologiesData = [
    {
        techName: "NodeJS",
        imgUrl: "node-icon.png"
    },
    {
        techName: "JavaScript",
        imgUrl: "javascript-icon.png"
    },
    {
        techName: "ReactJS",
        imgUrl: "react-icon.png"
    },
    {
        techName: "ExpressJS",
        imgUrl: "express-icon.png",
        large: true
    },
    {
        techName: "MongoDB",
        imgUrl: "mongodb-icon.png"
    },
    {
        techName: "HTML",
        imgUrl: "html-icon.png"
    },
    {
        techName: "CSS",
        imgUrl: "css-icon.png"
    },
    {
        techName: "Java",
        imgUrl: "java-icon.png",
        small: true
    },
    {
        techName: "C",
        imgUrl: "c-icon.png"
    },
    {
        techName: "Handlebars",
        imgUrl: "handlebars-icon.png",
    }   
]